var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _ellipse3, _ellipse4, _path5, _path6, _ellipse5, _ellipse6, _g, _mask, _g2, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 469,
    fill: "none",
    viewBox: "0 0 420 469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter0_f_27_93)",
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_27_93)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M237.144 435.522C232.718 444.384 223.747 450.446 213.401 450.446C198.666 450.446 186.721 438.151 186.721 422.986C186.721 420.811 186.957 418.613 187.406 416.38C185.259 421.659 184.053 426.696 184.053 431.612C184.053 446.778 195.998 459.072 210.733 459.072C224.178 459.072 235.3 448.836 237.144 435.522Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_27_93)",
    d: "M237.145 431.476C237.145 446.642 225.201 458.936 210.466 458.936C195.731 458.936 183.786 446.642 183.786 431.476C183.786 416.31 195.259 399.99 210.466 379C223.272 399.415 237.145 416.31 237.145 431.476Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.269,
    cy: 408.904,
    fill: "url(#paint2_radial_27_93)",
    rx: 27.346,
    ry: 28.754
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.795,
    cy: 440.246,
    fill: "url(#paint3_radial_27_93)",
    rx: 27.346,
    ry: 28.754
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter1_f_27_93)",
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial_27_93)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M159.257 361.804C155.306 369.203 147.296 374.265 138.058 374.265C124.902 374.265 114.237 363.999 114.237 351.337C114.237 349.521 114.447 347.686 114.848 345.822C112.931 350.229 111.855 354.435 111.855 358.539C111.855 371.202 122.52 381.467 135.676 381.467C147.68 381.467 157.61 372.921 159.257 361.804Z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_27_93)",
    d: "M159.259 358.426C159.259 371.089 148.594 381.354 135.438 381.354C122.282 381.354 111.617 371.089 111.617 358.426C111.617 345.763 121.86 332.137 135.438 314.611C146.872 331.657 159.259 345.763 159.259 358.426Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.512,
    cy: 339.579,
    fill: "url(#paint6_radial_27_93)",
    rx: 24.416,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.696,
    cy: 365.748,
    fill: "url(#paint7_radial_27_93)",
    rx: 24.416,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter2_f_27_93)",
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_radial_27_93)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M309.615 361.805C305.664 369.203 297.654 374.265 288.416 374.265C275.26 374.265 264.595 363.999 264.595 351.337C264.595 349.521 264.806 347.685 265.207 345.821C263.289 350.228 262.213 354.434 262.213 358.539C262.213 371.202 272.878 381.467 286.034 381.467C298.038 381.467 307.968 372.921 309.615 361.805Z",
    clipRule: "evenodd"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_radial_27_93)",
    d: "M309.617 358.426C309.617 371.089 298.952 381.354 285.796 381.354C272.64 381.354 261.975 371.089 261.975 358.426C261.975 345.763 272.218 332.137 285.796 314.611C297.23 331.657 309.617 345.763 309.617 358.426Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.87,
    cy: 339.579,
    fill: "url(#paint10_radial_27_93)",
    rx: 24.416,
    ry: 24.008
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.054,
    cy: 365.748,
    fill: "url(#paint11_radial_27_93)",
    rx: 24.416,
    ry: 24.008
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_27_93)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.291,
    cy: 87.67,
    fill: "url(#paint12_linear_27_93)",
    rx: 87.709,
    ry: 87.67
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_27_93",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 306L150.358 306C67.3176 306 0 238.843 0 156C0 73.1573 67.3176 6 150.358 6C217.131 6 273.738 49.4226 293.354 109.507C301.767 107.22 310.621 106 319.761 106C375.122 106 420 150.771 420 206C420 261.228 375.122 306 319.761 306Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_27_93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_27_93)",
    fillRule: "evenodd",
    d: "M319.761 306L150.358 306C67.3176 306 0 238.843 0 156C0 73.1573 67.3176 6 150.358 6C217.131 6 273.738 49.4226 293.354 109.507C301.767 107.22 310.621 106 319.761 106C375.122 106 420 150.771 420 206C420 261.228 375.122 306 319.761 306Z",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 306V305V306ZM319.761 306V307V306ZM293.354 109.507L292.403 109.817L292.698 110.721L293.616 110.472L293.354 109.507ZM150.358 307L319.761 307V305L150.358 305V307ZM-1 156C-1 239.397 66.7675 307 150.358 307V305C67.8676 305 1 238.288 1 156H-1ZM150.358 5C66.7675 5 -1 72.6027 -1 156H1C1 73.7118 67.8676 7 150.358 7V5ZM294.304 109.196C274.558 48.7118 217.575 5 150.358 5V7C216.687 7 272.918 50.1334 292.403 109.817L294.304 109.196ZM293.616 110.472C301.945 108.208 310.711 107 319.761 107V105C310.532 105 301.59 106.232 293.091 108.542L293.616 110.472ZM319.761 107C374.572 107 419 151.326 419 206H421C421 150.217 375.672 105 319.761 105V107ZM419 206C419 260.674 374.572 305 319.761 305V307C375.672 307 421 261.783 421 206H419Z",
    mask: "url(#path-14-inside-1_27_93)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_93",
    width: 69.091,
    height: 58.692,
    x: 176.053,
    y: 408.38,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_27_93",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_27_93",
    width: 63.402,
    height: 51.645,
    x: 103.855,
    y: 337.822,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_27_93",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_27_93",
    width: 63.402,
    height: 51.646,
    x: 254.213,
    y: 337.821,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_27_93",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_27_93",
    width: 175.418,
    height: 195.34,
    x: 230.582,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_27_93"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_27_93",
    width: 420,
    height: 348.647,
    x: 0,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_27_93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(210.733 433.481) rotate(-39.7879) scale(45.8304 33.5111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(210.466 433.345) rotate(-39.7879) scale(45.8304 33.5111)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(217.269 408.904) rotate(57.9574) scale(39.6886 11.251)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(200.328 440.246) rotate(51.8214) scale(21.5814 10.3351)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(135.676 360.1) rotate(-37.9116) scale(39.8546 28.7283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(135.438 359.986) rotate(-37.9116) scale(39.8546 28.7283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(141.512 339.579) rotate(56.2052) scale(33.8008 9.8486)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(126.386 365.748) rotate(49.9413) scale(18.5069 8.98477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(286.034 360.1) rotate(-37.9119) scale(39.8547 28.7284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(285.796 359.986) rotate(-37.9116) scale(39.8546 28.7283)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(291.87 339.579) rotate(56.2052) scale(33.8008 9.8486)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_27_93",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(276.744 365.748) rotate(49.9413) scale(18.5069 8.98477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_27_93",
    x1: 318.291,
    x2: 318.291,
    y1: 0,
    y2: 175.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_27_93",
    x1: 29.423,
    x2: 419.459,
    y1: 6,
    y2: 306.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLrain);
export default __webpack_public_path__ + "static/media/Lrain.f97e5bb34d9ab3da44aa8f95aa2864d7.svg";
export { ForwardRef as ReactComponent };